import { render } from "./ActivityDetailPanel.vue?vue&type=template&id=36b9335d&scoped=true"
import script from "./ActivityDetailPanel.vue?vue&type=script&lang=js"
export * from "./ActivityDetailPanel.vue?vue&type=script&lang=js"

import "./ActivityDetailPanel.vue?vue&type=style&index=0&id=36b9335d&lang=scss&scoped=true"
import "./ActivityDetailPanel.vue?vue&type=style&index=1&id=36b9335d&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b9335d"]])

export default __exports__